import React from 'react';

import { FlowSubscriptionButtonWithDialog,FlowSubscriptionButtonWithDialogProps } from '~src/flow/components/FlowSubscriptionButtonWithDialog';
import { FlowOutputStepInfo } from '~src/flow/models/FlowOutputStepInfo';
import { OutputFileFormat } from '~src/flow/serverApi/types/SubscriptionFlow';
import { Recipient } from '~src/flow/types/Recipient';

import { LinkedTaskFlowState } from '../../state/LinkedTaskStateTypes';
import { FlowLinkedTaskOptionsAction } from './FlowLinkedTaskOptions';

export type FlowSubscriptionConfigurationAction =
{ type: 'setShouldSendEmailWhenDone', payload: { index: number, value?: FlowSubscriptionButtonWithDialogProps['shouldSendEmailWhenDone'] }} |
{ type: 'toggleShouldSendToMe', payload: { index: number }} |
{ type: 'toggleAttachOutputDataToEmail', payload: { index: number }} |
{ type: 'toggleShowFirstNRows', payload: { index: number }} |
{ type: 'toggleIncludeLinkToDatasource', payload: { index: number }} |
{ type: 'changeFlowSubscriptionSubject', payload: { index: number, value: FlowSubscriptionButtonWithDialogProps['subjectValue'] }} |
{ type: 'changeFlowSubscriptionMessage', payload: { index: number, value: FlowSubscriptionButtonWithDialogProps['messageValue'] }} |
{ type: 'changeRecipients', payload: { index: number, value: FlowSubscriptionButtonWithDialogProps['emailRecipients'] }} |
{ type: 'changeFileFormat', payload: { index: number, value: FlowSubscriptionButtonWithDialogProps['outputFileFormat'] }} |
{ type: 'changeSelectedOutputForSubscription', payload: { index: number, value: FlowSubscriptionButtonWithDialogProps['selectedOutputForSubscription'], outputs: FlowSubscriptionButtonWithDialogProps['outputs'] }} |
{ type: 'toggleShouldIncludeOutputData', payload: { index: number}};


export type FlowSubscriptionButtonWithDialogForLinkedTasksProps = {
  readonly index: number;
  readonly flowLinkedTaskState: LinkedTaskFlowState;
  readonly outputs: ReadonlyArray<FlowOutputStepInfo>;
  readonly dispatch: React.Dispatch<FlowLinkedTaskOptionsAction>;
  readonly onDialogClose: () => void;
};

export const FlowSubscriptionButtonWithDialogForLinkedTasks: React.FC<FlowSubscriptionButtonWithDialogForLinkedTasksProps> =
  (props: FlowSubscriptionButtonWithDialogForLinkedTasksProps) => {
    const toggleShouldSendToMe = () => {
      props.dispatch({
        type: 'toggleShouldSendToMe',
        payload: { index: props.index }
      });
    };

    const toggleShouldIncludeOutputData = () => {
      props.dispatch({
        type: 'toggleShouldIncludeOutputData',
        payload: { index: props.index }
      });
    };

    const toggleAttachOutputDataToEmail = () => {
      props.dispatch({
        type: 'toggleAttachOutputDataToEmail',
        payload: { index: props.index }
      });
    };

    const toggleShowFirstNRows = () => {
      props.dispatch({
        type: 'toggleShowFirstNRows',
        payload: { index: props.index }
      });
    };

    const toggleIncludeLinkToDatasource = () => {
      props.dispatch({
        type: 'toggleIncludeLinkToDatasource',
        payload: { index: props.index }
      });
    };

    const changeSubject = (event: React.ChangeEvent<HTMLInputElement>) => {
      props.dispatch({
        type: 'changeFlowSubscriptionSubject',
        payload: { index: props.index, value: event.target.value }
      });
    };

    const changeMessage = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      props.dispatch({
        type: 'changeFlowSubscriptionMessage',
        payload: { index: props.index, value: event.target.value }
      });
    };

    const changeRecipients = (recipients: Recipient[]) => {
      props.dispatch({
        type: 'changeRecipients',
        payload: { index: props.index, value: recipients }
      });
    };

    const changeOutputFileFormat = (format: OutputFileFormat) => {
      props.dispatch({
        type: 'changeFileFormat',
        payload: { index: props.index, value: format }
    });
    };

    const changeSelectedOutput = (outputId: string) => {
      props.dispatch({
        type: 'changeSelectedOutputForSubscription',
        payload: { index: props.index, value: outputId, outputs: props.outputs }
      });
    };

    const flowSubscriptionButtonWithDialogProps: FlowSubscriptionButtonWithDialogProps = {
      outputs: props.outputs,
      shouldSendToMe: props.flowLinkedTaskState.flowSubscriptions.shouldSendToMe,
      subjectValue: props.flowLinkedTaskState.flowSubscriptions.subjectValue,
      messageValue: props.flowLinkedTaskState.flowSubscriptions.messageValue,
      shouldSendEmailWhenDone: props.flowLinkedTaskState.shouldSendEmailWhenDone,
      shouldIncludeOutputData: props.flowLinkedTaskState.flowSubscriptions.shouldIncludeOutputData,
      shouldShowFirstNRows: props.flowLinkedTaskState.flowSubscriptions.shouldShowFirstNRows,
      shouldAttachOutputDataToEmail: props.flowLinkedTaskState.flowSubscriptions.shouldAttachOutputDataToEmail,
      selectedOutputForSubscription: props.flowLinkedTaskState.flowSubscriptions.selectedOutputForSubscription,
      outputFileFormat: props.flowLinkedTaskState.flowSubscriptions.outputFileFormat,
      shouldIncludeLinkToDatasource: props.flowLinkedTaskState.flowSubscriptions.shouldIncludeLinkToDatasource,
      emailRecipients: props.flowLinkedTaskState.flowSubscriptions.emailRecipients,
      onDialogClose: props.onDialogClose,
      onShouldSendToMeToggled: toggleShouldSendToMe,
      onShouldIncludeOutputDataToggled: toggleShouldIncludeOutputData,
      onAttachOutputDataToEmailToggled: toggleAttachOutputDataToEmail,
      onShowFirstNRowsToggled: toggleShowFirstNRows,
      onIncludeLinkToDatasourceToggled: toggleIncludeLinkToDatasource,
      onSubjectChange: changeSubject,
      onMessageChange: changeMessage,
      onRecipientsChange: changeRecipients,
      onOutputFileFormatChange: changeOutputFileFormat,
      onSelectedOutputForSubscriptionChange: changeSelectedOutput,
    };

    return <FlowSubscriptionButtonWithDialog {...flowSubscriptionButtonWithDialogProps} />;
};
